import axios from "axios";
import { makeAutoObservable, toJS } from "mobx";

class SettingStore {
  fontSize = {};
  templateId = -1;

  reset() {
    this.fontSize = {};
    this.templateId = -1;
  }
  constructor() {
    makeAutoObservable(this);
  }
  setFontSize(value) {
    this.fontSize = value;
  }
  setTemplateId(value) {
    this.templateId = value;
  }
}

export default new SettingStore();
